'use client';

import type { ReactElement, ReactNode } from 'react';
import { focusVisibleOutline } from '@/lib/focus-styles';
import { cn } from '@/lib/utils';

export function RowButton({
    children,
    onMouseDown,
    onClick,
    'aria-label': ariaLabel,
}: {
    children: ReactNode;
    onMouseDown?: (e: React.MouseEvent<HTMLElement>) => void;
    onClick?: () => void;
    'aria-label'?: string;
}): ReactElement {
    return (
        <button
            type="button"
            data-suggestion-item="true"
            aria-label={ariaLabel}
            className={cn(
                'w-full flex items-center gap-2 py-2 outline-none cursor-pointer',
                cn('rounded-sm', focusVisibleOutline)
            )}
            onMouseDown={onMouseDown}
            onClick={onClick}>
            {children}
        </button>
    );
}
